<div class="page_content">
    
    <img class="pageicon" src="{{s_modal().img}}" />
    <br/>
    <h1 class="title">{{s_modal().title}}</h1>
    <br/>
    <p class="sub" [innerHtml]="s_modal().msg"></p>
    <br/>
    <div class="frm">
        <form (submit)="frm_send($event)">
            <input class="inputtxt" type="text" 
                [formControl]="frmname" placeholder="Nome" id="frmname" 
                [class.input-invalid]="!s_frm_name()" />
            <br/>
            <input class="inputtxt" type="text" 
                [formControl]="frmmail" value="" placeholder="Email" id="frmmail"
                [class.input-invalid]="!s_frm_mail()" />
            <br/>
            <input class="inputtxt" type="text" 
                [formControl]="frmphone" value="" placeholder="Telefone" id="frmphone"
                [class.input-invalid]="!s_frm_phone()" 
                mask="(00) 0.0000-0000" />
            <br/>
            <button class="btn-splatter">ENVIAR</button>
            <br/>
            <a (click)="frm_close()" class="btn ghost">VOLTAR</a>

        </form>
    </div>

    @if (b_loading()) {
        <app-loading></app-loading>
    }
    
</div>
